
<div class="panel panel-primary card" style="max-width: 62vw; margin: 0 auto; " >
  <div class="panel-heading card-header">
    <h3 class = "panel-title">{{form.title}}</h3></div>
    <div class="panel-body card-body">
      @for (formElement of form.elements; track formElement) {
        <div>
          <div>
            @switch (formElement.type) {
              <!-- File upload element -->
              @case ('upload') {
                <app-file-upload-element [fileupload] = "formElement" [processId] = "processId"
                  (onUploadDone)="onFileUpload(formElement.key, $event)"
                  [activeElements] = "this.enabledReferences"
                  >
                </app-file-upload-element>
              }
              @case ('file-static') {
                <app-file-upload-element [fileupload] = "formElement"
                  [activeElements] = "this.enabledReferences"
                  >
                </app-file-upload-element>
              }
              @case ('file-template') {
                <app-file-upload-element [fileupload] = "formElement"
                  [processId] = "processId"
                  [activeElements] = "this.enabledReferences"
                  >
                </app-file-upload-element>
              }
              @case ('table') {
                <app-table [table] = "formElement" [processId] = "processId" [taskKey]="taskKey"
                  >
                </app-table>
              }
              @case ('calendar') {
                <app-calendar [calendarElem] = "formElement" [elements]="form?.elements"
                  (onDateSet)="onChange(formElement.key, $event)"
                  [activeElements] = "this.enabledReferences" >
                </app-calendar>
              }
              @case ('table-dynamic') {
                <app-dynamic-table [table] = "formElement" [processId] = "processId"
                  [taskKey]="taskKey" [form]="form" [createDate]="createDate">
                </app-dynamic-table>
              }
              @case ('table-sheet') {
                <app-dynamic-table [table] = "formElement" [processId] = "processId"
                  [taskKey]="taskKey">
                </app-dynamic-table>
              }
              @case ('select') {
                <app-select [select]="formElement"  (onValueSelected)="onChange(formElement.key, $event)"></app-select>
              }
              @case ('radio') {
                <app-radio [radio]="formElement"
                  [targets] = "formElement.targets"
                  [rowKeyIndex] = "formElement.key"
                  [style.display]="enabledReferences[this.formElement?.enabled] ? 'block' : 'none'"
                (onValueSelected)="onChange(formElement.key, $event)"></app-radio>
              }
              @case ('checkbox') {
                <app-checkbox [checkbox]="formElement" [style.display]="enabledReferences[this.formElement?.enabled] ? 'block' : 'none'" (onValueSelected)="onChange(formElement.key, $event)"></app-checkbox>
              }
              <!-- rich text upload element -->
              @case ('richtext') {
                <app-rich-text-element [richtext] = "formElement"
                (onRichTextChange)="onChange(formElement.key, $event)"></app-rich-text-element>
              }
              @case ('static') {
                <span class="static-text">{{formElement.title}}</span>
              }
              @case ('static-bold-center') {
                <div class="static-text-center">{{formElement.title}}</div>
              }
              <!-- Other form elements -->
              @default {
                <div class="form-group ms-3 mb-2" [style.display]="enabledReferences[this.formElement?.enabled] ? 'block' : 'none'" style="padding-top: 15px;">
                  <!-- <label for="formElement.id">{{formElement.title}}:</label> -->
                  <label style="font-weight: 600;" for="{{formElement.id}}">{{(formElement.title && formElement.title!=="")?formElement.title+":":""}}</label>
                  <input type="text" class="form-control" id="{{formElement.key}}" type="{{formElement.type}}"
                    value = {{formElement.value}}
                    name="{{formElement.key}}"
                    (change)="onChange(formElement.key, $event.target.value)"
                    required>
                  </div>
                }
              }
            </div>
          </div>
        }
        @if (singleSave) {
          <button (click) = "saveForm()"  class="btn btn-primary" style="float: right;">
            {{'CONTROL-MODULE.SAVE' | translate}}
          </button>
        }
      </div>
    </div>

